module.exports = __webpack_public_path__ + "img/thriller.46c9b0a3.svg";